import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ProgressIndicator from '../ProgressIndicator/ProgressIndicator';

import './PaginationSimple.css';

const PageLink = ({ children, url, disabled }) => {
    if (disabled) {
        return (
            <div className="al-pagination-simple-item al-pagination-simple-item--disabled">
                <span className="al-button al-button--outline">
                    {children}
                </span>
            </div>
        );
    }

    return (
        <div className="al-pagination-simple-item">
            <Link to={url} className="al-button al-button--outline">
                {children}
            </Link>
        </div>
    );
};

const PaginationSimple = ({
    getUrl,
    currentPage,
    hideNexts,
    loading,
}) => {
    var page = parseInt(currentPage, 10) || 1;

    return (
        <div className="al-pagination-simple">
            <PageLink
                url={getUrl(page - 1)}
                disabled={page === 1 || loading}
            >
                <ChevronLeft size={18} />
                <span>Prev</span>
            </PageLink>

            {loading && <ProgressIndicator text=" " simpleClasses={true} />}

            <PageLink
                url={getUrl(hideNexts ? 1 : page + 1)}
                disabled={loading}
            >
                <span>Next</span>
                <ChevronRight size={18} />
            </PageLink>
        </div>
    );
};

PaginationSimple.propTypes = {
    getUrl: PropTypes.func.isRequired,
    currentPage: PropTypes.string,
    hideNexts: PropTypes.bool,
    loading: PropTypes.bool,
};

export default PaginationSimple;
